export default "https://cdn.questicon.mathletics.com/assets/images/progress-path-214e44e549bffed5aa1c7d26928e28c2.svg";